import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Main";
import App from "./App";
import DonatePage from "./components/DonateSection/DonatePage";
import FAQ from "./components/FAQ/FAQ";
import UpcomingEvents from "./components/Events/UpcomingEvents";

function AppRouter() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Main />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/upcoming-events" element={<UpcomingEvents />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AppRouter;
